import React from 'react';
import DataTable from '../DataTable/DataTable';

// Table without a title bar. Callers' `tableName` is intentionally not shown
// (these screens render their own heading). See DataTable.
export default function CustomTablePageNoHeader({
  tableHead, itemComponent, count, handleChangePage, page,
  noDataText, innerPaperMarginZero, pages,
  serverSide, totalCount, pageSize, onPageSizeChange, pageSizeOptions, loading, bare,
}) {
  return (
    <DataTable
      noTopMargin={innerPaperMarginZero}
      tableHead={tableHead}
      itemComponent={itemComponent}
      noDataText={noDataText}
      count={count}
      page={page}
      handleChangePage={handleChangePage}
      paginate={pages !== false}
      serverSide={serverSide}
      totalCount={totalCount}
      pageSize={pageSize}
      onPageSizeChange={onPageSizeChange}
      pageSizeOptions={pageSizeOptions}
      loading={loading}
      bare={bare}
    />
  );
}
